/*jshint unused:false*/
/*global fetch */
/*global console */

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}
let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}
window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

// Price toggles
function priceToggles() {
  let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
  let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
  let priceSwitchForm = [].slice.call(document.querySelectorAll('.price-toggle'));
  let toggleOn = [].slice.call(document.querySelectorAll('.price-toggle .toggles-on'));
  let toggleOff = [].slice.call(document.querySelectorAll('.price-toggle .toggles-off'));
  // let priceSwitchForm = document.getElementById('price-switch');
  let selected;
  allSwitches.forEach((value) => {
    value.addEventListener('change', (val) => {
      (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
      if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
        (val.target.checked === true) ? selected = 1 : selected = 0;
      }

      (selected === 0) ? toggleOn.forEach(value => { value.classList.add('active') }) : toggleOn.forEach(value => { value.classList.remove('active') });
      (selected === 1) ? toggleOff.forEach(value => { value.classList.add('active') }) : toggleOff.forEach(value => { value.classList.remove('active') });
      toggleSwitches();
      togglePrices();
      updatePrice();
      updateDerivativeForm();
      // val.target.scrollIntoView();
    })
  })
  let toggleSwitches = () => {
    allSwitches.forEach((v) => {
      (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
      (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
    })
    document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
    document.querySelectorAll(".price-title-type").forEach((v) => {
      v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
    })
  }
  let togglePrices = () => {
    priceContainers.forEach((v) => {
      (selected === 0) ? v.querySelectorAll('.price-personal').forEach(value => { value.classList.add('active') }) : v.querySelectorAll('.price-personal').forEach((value => { value.classList.remove('active') }));
      (selected === 1) ? v.querySelectorAll('.price-business').forEach(value => { value.classList.add('active') }) : v.querySelectorAll('.price-business').forEach((value => { value.classList.remove('active') }));
    })
  }
  let updatePrice = () => {
    let url = priceSwitchForm[0].getAttribute('action');
    let formData = new FormData(priceSwitchForm[0]);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
  let updateDerivativeForm = () => {
    let priceSwitch = document.querySelector('#quote-form select[name="type"]');
    if (priceSwitch) {
      priceSwitch.options[selected].selected = true;
      priceSwitch.dispatchEvent(new Event('change'));
    }
  }
}
priceToggles();
// End price Toggles


//Nav Toggle
function toggleNav(el) {
    var element = el;
    var menu = document.getElementById("site-menu");
    var header = document.querySelectorAll(".site-header")[0];
    menu.classList.toggle("active");
    header.classList.toggle("active");

    if(element.querySelector("span").classList.contains("more")){
      element.innerHTML = "<span class='close'></span> Close";
    } else {
      element.innerHTML = "<span class='more'></span> Menu";
    }
}

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');
const hamburgerSearch = document.querySelector('#headerSearch');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = 0;
    if (document.querySelector('.site-header').classList.contains('is-sticky')) {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight;
    } else {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
    }
    document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
    // document.querySelector('.site-menu') ? modalMobileNav.setFooterContent(document.querySelector('#price-switch').outerHTML) : null;
    // priceToggles();
  }
});
document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML) : null;

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if(hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

// Review Video Modals
const videoButton = document.querySelectorAll('.deal-gallery-main.video-trigger');
const videoModal = new tingle.modal({
  footer: false,
  closeMethods: ['overlay', 'button', 'escape'],
  closeLabel: "Close",
  cssClass: ['video-modal'],
  onClose: function() {
    this.setContent('');
  }
});
videoButton.forEach((value) => {
  value.addEventListener("click", function(e){
    const videoWrapper = document.querySelector('#review-video');
    const videoWrapperClone = videoWrapper.cloneNode(true);
    if (videoWrapperClone) {
      videoModal.setContent(videoWrapperClone);
      videoModal.open();
      videoWrapperClone.querySelector('video').play();
    }
  })
})
// END Review Video Modals

// Search Bar
var searchDropdown = function(){
    var searchRow = this.closest('.search-bar');
    searchRow.classList.toggle("active");
}

var searchBar = document.querySelectorAll(".search-bar .legend");

for(var i=0; i<searchBar.length; i++){
  searchBar[i].addEventListener('click', searchDropdown, false);
}


if(document.getElementsByClassName('toggle-search').length>0){
  document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
    e.preventDefault();
    if(document.querySelector('#popout-form')===null){
      window.location.href='/search';
      return false;
    }
    if(document.querySelector('#popout-form').classList.contains('hidden')){
      document.querySelector('#popout-form').classList.remove('hidden');
    } else {
      document.querySelector('#popout-form').classList.add('hidden');
    }
  });
}

// const searchSorter = document.querySelector('#search-sorter');
// if (searchSorter) {
//   searchSorter.addEventListener('change', (e) => {
//     const urlParams = new URLSearchParams(window.location.search);
//     urlParams.set('order', e.target.value);
//     window.location.search = urlParams;
//   })
// }

const searchReset = document.querySelector('.quick-search button.reset-form');
if (searchReset) {
  const allFields = document.querySelectorAll('.search-form .form-group select');
  searchReset.addEventListener('click', (e) => {
    allFields.forEach(value => {
      value.selectedIndex = 0;
      loadModels();
      loadSpecs();
    })
  })
}

// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('#manufacturer-header-content');
if(showMoreButton){
  if (showMoreButton.parentElement.querySelectorAll('.header-description > *').length > 1) {
    showMoreButton.addEventListener('click', (e) => {
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}


//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
var menuDropdown = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".menu-dropdown.active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
        }
    }
    
    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for(var i=0; i<dropdownTrigger.length; i++){
  dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


// //Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode.querySelector(".menu-dropdown");

//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     // //get current active class
//     // var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // // make it not active
//     // if(activeClass!=null){
//     //     for(var i=0; i<activeClass.length; i++){
//     //       activeClass[i].classList.toggle("active");
//     //     }
//     // }
    
//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown > a");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }


//Dropdown Menu Toggle
var showMenu = function(){
  //div inside element contains dropdown menu
  var dropdown = this.parentNode.querySelector('div');
  var menuToggle = this;

  //if it's already active set it not to be
  if(dropdown.classList.contains("active")){
    dropdown.classList.toggle("active");
    menuToggle.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("is-active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".dropdown-menu .active");
  // make it not active
  if(activeClass!=null){
    for(var i=0; i<activeClass.length; i++){
      activeClass[i].classList.toggle("active");
      activeClass[i].classList.toggle("is-active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
  dropdown.classList.toggle("is-active");
  menuToggle.classList.toggle("active");
  menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

// Toggle class for accordions
let acc = document.getElementsByClassName('mobile-accordion-header');
for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function(ev) {

    for (let i = 0; i < acc.length; i++) {
      if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
        continue;
      }
      acc[i].parentElement.classList.remove('active');
    }

    if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
      setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
    }
    this.parentElement.classList.toggle("active");

  });
}

//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }

  
//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }



//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}

// Search Sidebar
function setUrlParams(param, value, module) {
  let searchUrl = new URL(window.location.origin + window.location.pathname);

  let checkboxStock = document.querySelector('.checkbox [name=stock]');
  if (module === 'Search') {
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
    // checkboxStock ? searchUrl.searchParams.set('offers', param==='in_stock' ? 'stock' : (checkboxStock.checked ? 'stock' : '')) : null;
    checkboxStock ? searchUrl.searchParams.set('offers', checkboxStock.checked ? 'stock' : '') : null;
  } else if (window.location.pathname === '/car-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    checkboxStock ? searchUrl.searchParams.set('offers', checkboxStock.checked ? 'stock' : '') : null;
  } else if (window.location.pathname === '/van-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    checkboxStock ? searchUrl.searchParams.set('offers', checkboxStock.checked ? 'stock' : '') : null;
  } else {
    (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
    (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
    searchUrl.searchParams.set('filter', 'true');
    checkboxStock ? searchUrl.searchParams.set('in_stock', param==='in_stock' ? value : (checkboxStock.checked ? '1' : '')) : null;
  }
  if(param==='type'){
    searchUrl.searchParams.set('make', '');
    searchUrl.searchParams.set('model', '');
    searchUrl.searchParams.set('body_type', '');
  } else {
    searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside input[name="make"]:checked') ? document.querySelector('.search-aside input[name="make"]:checked').value : ''));
    searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside input[name="model"]:checked') ? document.querySelector('.search-aside input[name="model"]:checked').value : ''));
    param==='make' ? searchUrl.searchParams.set('model', '') : null;
    searchUrl.searchParams.set('body_type', param==='body_type' ? value : (document.querySelector('.search-aside input[name="body_type"]:checked') ? document.querySelector('.search-aside input[name="body_type"]:checked').value : ''));
  }
  searchUrl.searchParams.set('budget', param==='budget' ? value : (document.querySelector('.search-aside input[name="budget"]:checked') ? document.querySelector('.search-aside input[name="budget"]:checked').value : ''));
  searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside input[name="transmission"]:checked') ? document.querySelector('.search-aside input[name="transmission"]:checked').value : ''));
  searchUrl.searchParams.set('fuel_type', param==='fuel_type' ? value : (document.querySelector('.search-aside input[name="fuel_type"]:checked') ? document.querySelector('.search-aside input[name="fuel_type"]:checked').value : ''));
  searchUrl.searchParams.set('co2', param==='co2' ? value : (document.querySelector('.search-aside input[name="co2"]:checked') ? document.querySelector('.search-aside input[name="co2"]:checked').value : ''));
  searchUrl.searchParams.set('order', param==='order' ? value : (document.querySelector('.search-heading select[name="order"]') ? document.querySelector('.search-heading select[name="order"]').value : ''));

  window.location.href = searchUrl;
}

if (document.querySelector('.search-aside')) {
  if (document.querySelector('#search-type') && document.querySelector('.search-aside input[name="make"]:checked')) {
    loadModelsRadio(document.querySelector('#search-type').value, document.querySelector('.search-aside input[name="make"]:checked').value)
  }
  if (document.querySelector('#search-type')) {
    loadBodyTypesRadio(document.querySelector('#search-type').value)
  }

  if (document.querySelector('.button-clear[data-type="make"]') && document.querySelector('.search-aside input[name="make"]:checked')) {
    document.querySelector('.button-clear[data-type="make"] > span').innerText = document.querySelector('.search-aside input[name="make"]:checked').id.toUpperCase();
  }

  (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');

  let checkboxStock = document.querySelector('.checkbox [name=stock]');
  if(checkboxStock){
    checkboxStock.addEventListener('change', (ev) => {
      document.body.classList.remove('loaded');
      setUrlParams('in_stock', (checkboxStock.checked) ? '1' : '', checkboxStock.dataset.module, document.querySelector('.search-content').dataset.module);
    })
  }
  document.querySelectorAll('.search-aside input[name="make"]').forEach(v => {
    v.addEventListener('change', e => {
      document.body.classList.remove('loaded');
      setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
    })
  })
  document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
    v.addEventListener('change', e => {
      document.body.classList.remove('loaded');
      setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
    })
  })
  document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
    v.addEventListener('change', e => {
      document.body.classList.remove('loaded');
      setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
    })
  })
  document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
    v.addEventListener('change', e => {
      document.body.classList.remove('loaded');
      setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
    })
  })
  document.querySelectorAll('.search-aside input[name="co2"]').forEach(v => {
    v.addEventListener('change', e => {
      document.body.classList.remove('loaded');
      setUrlParams('co2', e.target.value, document.querySelector('.search-content').dataset.module);
    })
  })
  document.querySelector('.search-heading select[name="order"]').addEventListener('change', e => {
    document.body.classList.remove('loaded');
    setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
  })
  document.querySelectorAll('.button-clear').forEach(v => {
    v.addEventListener('click', e => {
      document.body.classList.remove('loaded');
      setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
    })
  })
}



/** 
  * SEARCH
  */
function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  let slider = document.querySelector('.vehicle-type .slider');
  slider ? slider.classList.toggle("active") : null;
  // let toggleMakes = document.querySelectorAll('.search-form .form-group[data-field="make"] > div.radio-switch');
  // toggleMakes.forEach( v => { v.classList.toggle('active') })

  if (document.querySelector('.search-aside')) {
    document.body.classList.remove('loaded');
    setUrlParams('type', searchType, document.querySelector('.search-content').dataset.module);
  } else {
    // loadManufacturers(document.querySelector('#search-type').value);
    if (document.querySelector('.ev-search')){
      loadEvManufacturers(document.querySelector('#search-type').value);
    } else {
      // loadManufacturers(document.querySelector('#search-type').value);
    }

    loadBodyTypes(document.querySelector('#search-type').value);
    loadSpecs(document.querySelector('#search-type').value);

    var dropdown = document.getElementsByName('model')[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

  }
}

function loadManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Choose a Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.has('make') ? document.querySelector('.search-form [name="make"]').value = urlParams.get('make') : null;
      urlParams.has('make') ? document.querySelector('.search-form [name="make"]').dispatchEvent(new Event('change')) : null;
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadEvManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Manufacturer';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if($type) {
      let url = '/api/' + $type + '/manufacturers/ev';
      fetch(url).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        let keysSorted = Object.keys(data).sort(function (a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
      });

    }
  }
}

function loadModels($type, $manufacturer) {

  let defaultOption = document.createElement('option');
  defaultOption.text = 'Model';
  defaultOption.value = '';
  let loadingOption = document.createElement('option');
  loadingOption.text = 'Loading...';
  loadingOption.value = '';
  let loadingError = document.createElement('option');
  loadingError.text = 'Loading Error, please check your internet connection';
  loadingError.value = '';

  var model_dropdowns = document.querySelector('select[name="model"]');
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      dropdown.length = 0;
      dropdown.add(loadingOption);
      dropdown.selectedIndex = 0;

      var url = '/api/'+$type+'/models/'+$manufacturer;

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        dropdown.length = 0;
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const makeParam = urlParams.get('make');
        const modelParam = urlParams.get('model');
        if (modelParam && makeParam == $manufacturer) {
          dropdown.value = modelParam;
          loadSpecs($type, modelParam);
        }
      }).catch(function(err) {
        dropdown.length = 0;
        dropdown.add(loadingError);
        dropdown.selectedIndex = 0;
        console.error('Fetch Error -', err);
      });
    }
  }
}

function loadModelsRadio($type, $manufacturer) {
  const wrapper = document.querySelector('#model-wrapper');
  if (wrapper && $type && $manufacturer) {
    let url = '/api/'+$type+'/models/'+$manufacturer;
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let selectedModel = new URLSearchParams(window.location.search).get('model');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'model');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedModel) ? input.setAttribute('checked', 'true') : null;
        label.innerText = text;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('toggles');
        wrapper.appendChild(input);
        wrapper.appendChild(label);
      }
      document.querySelectorAll('.search-aside input[name="model"]').forEach(v => {
        v.addEventListener('change', e => {
          document.body.classList.remove('loaded');
          setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span').innerText = document.querySelector('.search-aside input[name="model"]:checked').id.toUpperCase();
      }
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypesRadio($type) {
  const wrapper = document.querySelector('#body_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/types';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let span = document.createElement("span");
        let selectedBodyType = new URLSearchParams(window.location.search).get('body_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'body_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedBodyType) ? input.setAttribute('checked', 'true') : null;
        label.innerText = text;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('toggles');
        span.classList.add('checkmark');
        wrapper.appendChild(input);
        wrapper.appendChild(label);
        label.prepend(span);
      }

      document.querySelectorAll('.search-aside input[name="body_type"]').forEach(v => {
        v.addEventListener('change', e => {
          document.body.classList.remove('loaded');
          setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadEvModels($type, $manufacturer) {
  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if($type && $manufacturer) {
      let url = '/api/' + $type + '/models/' + $manufacturer + '/ev';

      fetch(url).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        let keysSorted = Object.keys(data).sort(function (a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
      });

    }
  }

}

function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types';

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    let keysSorted = Object.keys(data).sort(function(a, b) {
      return data[a].localeCompare(data[b])
    });
    for (let x in keysSorted) {
      let option = document.createElement('option');
      option.text = data[keysSorted[x]];
      option.value = keysSorted[x];
      dropdown.add(option);
    }
  }).catch(function(err) {
    console.error('Fetch Error -', err);
  });
}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec_level')[0];
  if (dropdown){
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Spec';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    dropdown.length = 0;
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($model) {
      dropdown.length = 0;
      dropdown.add(loadingOption);
      dropdown.selectedIndex = 0;
      var url = '/api/'+$type+'/specs/'+$model;

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        dropdown.length = 0;
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const modelParam = urlParams.get('model');
        const specParam = urlParams.get('spec_level');
        if (specParam && modelParam == $model) {
          dropdown.value = specParam;
        }
      }).catch(function(err) {
        dropdown.length = 0;
        dropdown.add(loadingError);
        dropdown.selectedIndex = 0;
        console.error('Fetch Error -', err);
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  // Feefo Reviews
  const xhttp = new XMLHttpRequest();
  xhttp.onload = function() {
    let reviewsTop = document.querySelector('#feefo_top');
    if(this.response && reviewsTop){
      reviewsTop.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
      reviewsTop.querySelector('#reviews_text > tspan:last-child').innerHTML = `${JSON.parse(this.response).meta.count} Reviews`;
      reviewsTop.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
      reviewsTop.classList.remove('visuallyhidden');
    } else {
      reviewsTop ? reviewsTop.classList.add('visuallyhidden') : null;
    }

    let reviewsHero = document.querySelector('#feefo_hero');
    if(this.response && reviewsHero) {
      reviewsHero.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
      reviewsHero.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
      reviewsHero.classList.remove('visuallyhidden');
    } else {
      reviewsHero ? reviewsHero.classList.add('visuallyhidden') : null;
    }

  }
  xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=planet-leasing");
  xhttp.send();

  // Search Sidebar
  // let filterSwitch = document.querySelectorAll('.filter-switch');
  // if(filterSwitch){
  //   Array.prototype.slice.call(filterSwitch, 0).forEach((value) => {
  //     value.addEventListener('click', () => {
  //       document.querySelector('#page').classList.toggle('open');
  //       document.querySelector('.search-results-filters').classList.toggle('open');
  //       // document.querySelector('.search-results-filters-switch').classList.toggle('open');
  //     })
  //   })
  // }
  // let breadcrumbsSwitch = document.querySelector('.breadcrumbs-search.filter-switch');
  // if (breadcrumbsSwitch){
  //   document.querySelector('#page').classList.add('has-search');
  // }
  // let searchPage = document.querySelector('.breadcrumbs.search-page');
  // if (searchPage){
  //   document.querySelector('#page').classList.add('search-page');
  // }
  // END Search Sidebar

  // Latest Offers - Show More
  // document.querySelectorAll('.offers-strip-more').forEach(value => {
  //   value.addEventListener('click', (e) => {
  //     e.target.closest('.offers-strip').classList.toggle('show-more');
  //   })
  // })

  document.querySelectorAll('.offers-strip-more').forEach(value => {
    value.addEventListener('click', (e) => {
      let element = e.target.closest('.offers-strip');
      let showMore = element.querySelector('span.show-more-btn');

      element.classList.toggle('show-more');
      if(element.classList.contains('show-more')){
        showMore.innerHTML = 'Show less';
      } else {
        showMore.innerHTML = 'Show more';
      }
    })
  })

  // var classname = document.querySelectorAll(".offers-strip-more");
  //
  // var showMore = function(e) {
  //   e.preventDefault();
  //   let element = classname.closest('.offers-strip');
  //   element.classList.toggle("active");
  //   if(element.classList.contains('active')){
  //     this.innerHTML = 'Hide additional options';
  //   } else {
  //     this.innerHTML = 'Show me more options';
  //   }
  // };
  //
  // for (var i = 0; i < classname.length; i++) {
  //   classname[i].addEventListener('click', showMore, false);
  // }


  // Hero Slider
  const heroSlider = document.querySelector('#hero-offer-wrapper > div:not(.glider-arrows)')
  if (heroSlider) {
    new Glider(heroSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: false,
      scrollLock: true,
      arrows: {
        prev: '#hero-offer-wrapper .glider-prev',
        next: '#hero-offer-wrapper .glider-next'
      },
      responsive: [
        {
          breakpoint: 769,
          settings: {
            draggable: false,
          }
        }
      ]
    })
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }
  // END Derivative Gallery Slider

  // Derivative Offer Slider
  const dealOfferSlider = document.querySelector('.deal-offers-track');
  if (dealOfferSlider) {
    new Glider(dealOfferSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-offers-controls .glider-prev',
        next: '.deal-offers-controls .glider-next'
      },
      // responsive: [
      //   {
      //     breakpoint: 767,
      //     settings: {
      //       slidesToShow: 1,
      //       draggable: false
      //     }
      //   }
      // ]
    })
  }
  // END Derivative Offer Slider


  // Table Sorting
  function sortTable(elem, name, direction) {
    let sortName,sortDirection;
    if (name && direction) {
      sortName = name;
      sortDirection = direction;
    } else {
      sortName = elem.composedPath()[0].dataset.sortname;
      sortDirection = elem.composedPath()[0].dataset.sortdirection;
    }
    let tableBody = document.querySelector('.model-table-body');
    let tableRows = Array.from(tableBody.children);
    tableRows.pop();

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      if (sortName === 'price') {
        return (dir === 'asc') ? b.localeCompare(a, 'en', {numeric: true}) : a.localeCompare(b, 'en', {numeric: true});
      }
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }

  // Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  let sortDropdown = document.querySelector('#table-sorter');
  if (sortDropdown) {
    sortDropdown.addEventListener('change', (e) => {
      (e.target.value === 'price_asc') ? sortTable(null, 'price', 'desc') : null;
      (e.target.value === 'price_desc') ? sortTable(null, 'price', 'asc') : null;
      (e.target.value === 'offers') ? sortTable(null, 'offer', 'asc') : null;
      (e.target.value === 'stock') ? sortTable(null, 'stock', 'asc') : null;
    })
  }

  // Show no results text
  const showNoResults = function() {
    if(!document.querySelectorAll('.model-table-wrapper:not([class*="hidden"]):not(.no-results)').length > 0) {
      document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
    } else {
      document.querySelector('.no-results').classList.add('hidden-no-results');
    }
  }

  // Show stock offers only
  let checkboxStock = document.querySelector('.checkbox [name=stock]');
  let modelNonStockDeals = document.querySelectorAll('#model-table .model-table-wrapper[data-stock="0"]');
  if(checkboxStock && modelNonStockDeals){
    checkboxStock.addEventListener('change', (ev) => {
      if (ev.target.checked === true) {
        modelNonStockDeals.forEach((value) => {
          value.classList.add('visuallyhidden')
          showNoResults();
        })
      } else {
        modelNonStockDeals.forEach((value) => {
          value.classList.remove('visuallyhidden')
          showNoResults();
        })
      }
    })
  }

  // Model Table Search
  if (document.querySelector('#filters-form')) {
    let filterFields = document.querySelectorAll('#filters-form .filters input');
    const filterTable = (field, value) => {
      let searchType = field;

      if (value !== '' && value.length > 0) {
        let elements = document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']');
        elements.forEach((v) => {
          v.classList.add('hidden-' + field + '')
          if(v.getAttribute('data-' + searchType + '').includes(value)) {
            v.classList.remove('hidden-' + field + '')
          }
        })
      } else {
        document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']').forEach((v) => {
          v.classList.remove('hidden-' + field + '')
        });
      }

      // Show no results text
      showNoResults();
    }
    if (filterFields) {
      filterFields.forEach((value => {
        value.addEventListener('change', (event) => {
          let val = value.value;
          let field = value.getAttribute('name');

          filterTable(field, val);

          if(val===field +"-any"){
            document.querySelectorAll('.model-table-wrapper[data-' + field + ']').forEach((v) => {
              v.classList.remove('hidden-' + field + '')
              showNoResults()
            });
          }
        })
      }))
    }
  }
  // End Model Table Search

  // Model Table Search Mobile
  if (document.querySelector('#filters-form-mobile')) {
    let filterFields = document.querySelectorAll('#filters-form-mobile .filters input');
    const filterTable = (field, value) => {
      let searchType = field;

      if (value !== '' && value.length > 0) {
        let elements = document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']');
        elements.forEach((v) => {
          v.classList.add('hidden-' + field + '')
          if(v.getAttribute('data-' + searchType + '').includes(value)) {
            v.classList.remove('hidden-' + field + '')
          }
        })
      } else {
        document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']').forEach((v) => {
          v.classList.remove('hidden-' + field + '')
        });
      }

      // Show no results text
      showNoResults();
    }
    if (filterFields) {
      filterFields.forEach((value => {
        value.addEventListener('change', (event) => {
          let val = value.value;
          let field = value.getAttribute('name');

          filterTable(field, val);

          if(val===field +"-any"){
            document.querySelectorAll('.model-table-wrapper[data-' + field + ']').forEach((v) => {
              v.classList.remove('hidden-' + field + '')
              showNoResults()
            });
          }
        })
      }))
    }
  }
  // End Model Table Search Mobile

  // Model Table Terms
  function loadTablePrices(vehicleType, vehicleIds) {
    let priceView, term, profile, mileage;
    priceView = (document.querySelector('#switch-price-type')) ? document.querySelector('#switch-price-type').value : null;
    term = (document.querySelector('#filters-form input[name="term"]:checked')) ? document.querySelector('#filters-form input[name="term"]:checked').value : null;
    profile = (document.querySelector('#filters-form input[name="profile"]:checked')) ? document.querySelector('#filters-form input[name="profile"]:checked').value : null;
    mileage = (document.querySelector('#filters-form input[name="mileage"]:checked')) ? document.querySelector('#filters-form input[name="mileage"]:checked').value : null;

    // add loaders
    document.querySelectorAll('.price-from > div.active').forEach(element => element.classList.add('price-loader'));
    document.querySelectorAll('.filter-form-terms').forEach(element => element.classList.add('filter-loader'));

    let url = `/api/${vehicleType}/price/bulk?${vehicleIds}term=${term}&initial_profile=${profile}&mileage=${mileage}&price_view=${priceView}`;
    fetch(url, {
      method: 'GET',
      // body: formData,
    }).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function (data) {
      if(data){
        data.forEach((v, i) => {
          if (v) {
            if (vehicleType === 'van') {
              document.querySelector(`.model-table-wrapper[data-id="${v.van_id}"] .price-from > div.active > span`).innerHTML = (v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA';
            } else {
              document.querySelector(`.model-table-wrapper[data-id="${v.car_id}"] .price-from > div.active > span`).innerHTML = (v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA';
            }
          } else {
            document.querySelector(`.model-table-wrapper:nth-child(${i+1}) .price-from > div.active > span`).innerHTML = 'POA';
          }
        })
        // remove loaders
        document.querySelectorAll('.price-from > div.active').forEach(element => element.classList.remove('price-loader'));
        document.querySelectorAll('.filter-form-terms').forEach(element => element.classList.remove('filter-loader'));
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
  if (document.querySelector('#filters-form') && document.querySelectorAll('.model-table-body > .model-table-wrapper:not(.no-results)').length > 0) {
    let tableRows = document.querySelectorAll('.model-table-body > .model-table-wrapper:not(.no-results)');
    let vehicleIds = '';
    let vehicleType = document.querySelector('.model-table-body > .model-table-wrapper:not(.no-results)').dataset.type;
    tableRows.forEach(v => {
      vehicleIds += `ids[]=${v.dataset.id}&`
    })

    loadTablePrices(vehicleType, vehicleIds)
    document.querySelectorAll('#filters-form > .form-group.filter-form-terms, .price-toggle').forEach(value => {
      value.addEventListener('change', e => {
        loadTablePrices(vehicleType, vehicleIds)
      })
    })
  }
  // End Model Table Terms

  // Advanced Search
  document.getElementById('toggleAdvanced') ? document.getElementById('toggleAdvanced').addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('.form select[name="budget"]').selectedIndex = 0;
    document.getElementById('search-bar').classList.toggle('search-advanced');
  }) : null;

  // Share Toggle
  const shareContainer = document.querySelector('#share');
  if (shareContainer){
    shareContainer.querySelector('.share-front').addEventListener('click', () => {
      shareContainer.querySelector('.share-front').classList.add('invisible');
      shareContainer.querySelector('.share-back').classList.remove('invisible');
    })
  }


  // Calculators
  function loadManufacturersCalc($type, $ev = false) {
    var make_dropdowns = document.getElementsByName("calculator-make");
    for (i = 0; i < make_dropdowns.length; i++) {

      var dropdown = make_dropdowns[0];
      dropdown.length = 0;

      var defaultOption = document.createElement('option');
      defaultOption.text = 'Select Manufacturer';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      let url;
      ($ev) ? url = '/api/' + $type + '/manufacturers/ev' : url = '/api/' + $type + '/manufacturers';

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  // Load Models Dropdown
  function loadModelsCalc($type, $manufacturer, $ev = false, $inactive = false, $compare = false) {
    let model_dropdowns, derivative_dropdowns;
    ($compare) ? model_dropdowns = document.getElementsByName("calculator-model-compare") : model_dropdowns = document.getElementsByName("calculator-model");
    ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
    for (let i = 0; i < derivative_dropdowns.length; i++) {
      let dropdown = derivative_dropdowns[i];
      dropdown.length = 0;
      let defaultOption = document.createElement('option');
      defaultOption.text = 'Select Variant';
      defaultOption.value = '';
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
    }
    for (let i = 0; i < model_dropdowns.length; i++) {
      let dropdown = model_dropdowns[i];
      dropdown.length = 0;

      let defaultOption = document.createElement('option');
      defaultOption.text = 'Select Model';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      let url;
      ($ev) ? url = '/api/' + $type + '/models/' + $manufacturer + '/ev' : url = '/api/' + $type + '/models/' + $manufacturer;

      let params;
      ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';

      fetch(url + params).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  // Load Derivatives Dropdown
  function loadDerivativeCalc($type, $model, $default = false, $ev = false, $inactive = false, $compare = false) {
    let derivative_dropdowns;
    ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
    for (let i = 0; i < derivative_dropdowns.length; i++) {
      let dropdown = derivative_dropdowns[i];
      dropdown.length = 0;

      if ($default){
        let defaultOption = document.createElement('option');
        defaultOption.text = 'Select Variant';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
      }

      let url;
      ($ev) ? url = '/api/' + $type + '/derivatives/' + $model + '/ev' : url = '/api/' + $type + '/derivatives/' + $model;

      let params;
      if($compare) {
        ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive', 'compare_ev': 'true'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
      } else {
        ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
      }

      fetch(url + params).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          if (x === '2813'){ continue }
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  // Compare Vehicles
  if (document.querySelector('body').classList.contains('page-compare-vehicles')) {
    // Indicative Fuel Cost
    function indicativeCost($fuel_type = false, $mpg = null, $electric_range = null, $battery_size = null, $electricity_cost = null) {
      let indicativeCost;
      if ($fuel_type === 'Electric' && $electric_range && $battery_size){
        let electricity_cost = ($electricity_cost) ? $electricity_cost : document.getElementById('average-data').dataset.averageElectricity;
        let miles_per_kwh = $electric_range / $battery_size;
        let cost_per_mile = electricity_cost / miles_per_kwh;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type === 'Diesel' && $mpg) {
        let cost_per_litre_diesel = document.getElementById('average-data').dataset.averageDiesel;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_diesel / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type !== false && $mpg) {
        let cost_per_litre_petrol = document.getElementById('average-data').dataset.averagePetrol;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_petrol / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else {
        indicativeCost = 'N/A';
      }
      return indicativeCost;
    }

    loadManufacturersCalc('car', false);
    let comparisonTable = document.getElementById('car-comparison')
    let makeField = document.querySelector('select[name=calculator-make]')
    let modelField = document.querySelector('select[name=calculator-model]')
    let derivativeField = document.querySelector('select[name=calculator-derivative]')

    function compareColumns(row, reverse = false, blue = false) {
      let largest = 0
      let smallest = 9999
      comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
        if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
          (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
          (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
          comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
          if(largest !== smallest) {
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
          }
        }
      })
    }

    function loadPrice($spot, $derivative) {
      comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
      comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = 'Loading...';

      document.querySelector('input[name="car_id"]').value = $derivative;
      let url = '/api/car/price/' + $derivative;
      let formData = new FormData(document.getElementById('car-comparison'));
      fetch(url, {
        method: 'POST',
        body: formData,
      }).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        if (data) {
          comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.monthly_rental != null) ? '£' + data.monthly_rental : 'N/A';
          (parseInt(data.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.monthly_rental) : '';
          compareColumns('price', true);
          // comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.term != null) ? data.term + ' months' : 'N/A';
          // (parseInt(data.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.term) : '';
          // comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.initial_profile != null) ? data.initial_profile + ' months' : 'N/A';
          // (parseInt(data.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.initial_profile) : '';
          // comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.mileage != null) ? data.mileage + ' miles' : 'N/A';
          // (parseInt(data.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.mileage) : '';
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
        document.getElementsByClassName('price')[0].classList.remove('hidden');
        document.getElementsByClassName('price-fetching')[0].classList.add('hidden');
      });
    }

    function setLinks($spot, $active, $url, $fuel) {
      let params = '?' + new URLSearchParams({
        'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
        'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
        'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
      });
      ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a`).classList.add('visuallyhidden');
      ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a`).classList.add('visuallyhidden');
      ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');
    }

    function loadVehicle($spot, $derivative) {
      if ($derivative !== 0) {
        let url = '/api/car/' + $derivative;
        let params = '?' + new URLSearchParams({'type': (document.querySelector('#car-comparison input[name=type]')).value});
        fetch(url + params).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let getCapTechnicalData;
          if(data.car.technical) {
            getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
          } else {
            getCapTechnicalData = ($category, $term) => 'N/A';
          }
          comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

          comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
          comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .derivative`).innerText = data.car.name;

          setLinks($spot, data.car.active, data.car.full_url, data.car.fuel_type);

          comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('data-std', data.car.main_img);
          comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', (data.car.main_img.replace('/images/new/std/', '/images/new/big/')));

          comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + (parseFloat(data.car.base_price)).toFixed(0) : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
          (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
          compareColumns('electric-range');
          comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
          (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
          compareColumns('real-electric-range');

          comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
          (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
          compareColumns('official-mpg');
          comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
          (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
          compareColumns('real-mpg');

          let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
          comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
          (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
          compareColumns('indicative-cost', true);

          // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
          // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
          comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? data.car.co2 + ' g/km' : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
          // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
          // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

          if (data.car.tax_band) {
            comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
            (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
            compareColumns('first-year-rate', true);
            comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
            (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
            compareColumns('year-rate', true);
          }

          if (data.car.fuel_type === 'Petrol') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
          } else if (data.car.fuel_type === 'Diesel') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
          } else if (data.car.fuel_type === 'Electric') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
          } else {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
          }

          if (data.car.tax) {
            comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
            (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
            compareColumns('bik-1', true);
            comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
            (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
            compareColumns('bik-2', true);
            comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
            (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
            compareColumns('bik-3', true);
          }

          if (data.car.from_price) {
            comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.car.from_price.monthly_rental != null) ? '£' + data.car.from_price.monthly_rental : 'N/A';
            (parseInt(data.car.from_price.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.monthly_rental) : '';
            compareColumns('price', true);
            comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.car.from_price.term != null) ? data.car.from_price.term + ' months' : 'N/A';
            (parseInt(data.car.from_price.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.term) : '';
            comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.car.from_price.initial_profile != null) ? data.car.from_price.initial_profile + ' months' : 'N/A';
            (parseInt(data.car.from_price.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.initial_profile) : '';
            comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.car.from_price.mileage != null) ? data.car.from_price.mileage + ' miles' : 'N/A';
            (parseInt(data.car.from_price.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.mileage) : '';
          }

          comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
          (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
          compareColumns('engine-size', false, true);
          comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
          comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
          (parseInt(getCapTechnicalData('Performance', 'Engine Power - BHP').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
          compareColumns('engine-power', false, true);
          comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
          (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
          compareColumns('acceleration', false, true);
          comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
          (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
          compareColumns('top-speed', false, true);
          if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
            for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
              let star = document.createElement("img");
              star.setAttribute('src', '/themes/osv-full/img/icons/general/star-gold.svg');
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
            }
          } else {
            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
          }
          comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

          ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

          loadModelsCalc('car', 0, false, false)

          loadPrice($spot, $derivative)

          comparisonTable.reset();
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }

    function updateParams() {
      let params = '?' + new URLSearchParams({
        'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
        'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
        'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
      });
      comparisonTable.querySelectorAll(`[data-cell-content="cta_top"] a, [data-cell-content="model"] a, [data-cell-content="cta"] a`).forEach((value) => {
        let url;
        (value.getAttribute('href').split('?')[0].includes('/car-leasing/')) ? url = value.getAttribute('href').split('?')[0] + params : url = value.getAttribute('href').split('?')[0];
        value.setAttribute('href', url);
      })
    }


    document.querySelectorAll('.quote-terms').forEach((value) => {
      value.addEventListener('change', (ev) => {
        loadPrice('first', document.querySelector('#car-comparison').dataset.carFirst);
        loadPrice('second', document.querySelector('#car-comparison').dataset.carSecond);
        loadPrice('third', document.querySelector('#car-comparison').dataset.carThird);
        updateParams();
        ev.target.classList.add('visuallyhidden');
        ev.composedPath()[1].querySelector('button').classList.remove('visuallyhidden');
      })
    })

    document.querySelectorAll('#toggle-term, #toggle-profile, #toggle-mileage').forEach((value) => {
      value.addEventListener('click', (ev) => {
        ev.target.classList.add('visuallyhidden');
        ev.composedPath()[1].querySelector('select').classList.remove('visuallyhidden');
      })
    })

    makeField.addEventListener('change', () => {
      (makeField.value > 0) ? loadModelsCalc('car', makeField.value, false, false) : false;
    })

    modelField.addEventListener('change', () => {
      (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, false, false, false) : false;
      derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
    });

    setTimeout(() => {
      (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
    }, 200);
    setTimeout(() => {
      (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
    }, 400);
    setTimeout(() => {
      if (comparisonTable.dataset.carThird > 1) {
        loadVehicle('third', comparisonTable.dataset.carThird);
        comparisonTable.setAttribute('data-car-form', '0');
      }
    }, 1000);

    derivativeField.addEventListener('change', (event) => {
      if(event.target.value > 0) {

        if(parseInt(comparisonTable.dataset.carFirst) < 1) {
          loadVehicle('first', event.target.value)
        } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
          loadVehicle('second', event.target.value)
        } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
          loadVehicle('third', event.target.value)
        } else { }

        let cookie = Cookies.get('compare_list')
        let range_name = derivativeField.dataset.range
        if (cookie) {
          let cookie_obj = JSON.parse(cookie);
          if (Object.keys(cookie_obj).length < 3) {
            if (cookie_obj[event.target.value] === undefined) {
              cookie_obj = {...cookie_obj, [event.target.value] : range_name};
              let cookie_string = JSON.stringify(cookie_obj)
              Cookies.set('compare_list', cookie_string)
            }
          }
        } else {
          let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
          let cookie_string = JSON.stringify(cookie_obj)
          Cookies.set('compare_list', cookie_string)
        }

      }
    })

    function resetSlot($slot, $id) {
      comparisonTable.setAttribute('data-car-form', '1');
      document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
      document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
      if ($slot === 'first') {
        comparisonTable.setAttribute('data-car-first', '-1');
      } else if ($slot === 'second') {
        comparisonTable.setAttribute('data-car-second', '-1');
      } else {
        comparisonTable.setAttribute('data-car-third', '-1');
      }

      let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
      [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
        if (index === 0) {
          (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
          (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
          (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
          let cookie = Cookies.get('compare_list');
          let cookie_obj = JSON.parse(cookie);
          delete cookie_obj[$id];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
        }
      })

    }
    document.querySelectorAll('.car-comparison-table-row--img>div[data-car] .reset').forEach(value => {
      value.addEventListener('click', evt => {
        comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
        (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
        (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
        (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
      })
    })

  }
  // Add To Compare
  document.querySelectorAll('button[data-compare]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
            e.target.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/osv-full/img/icons/minus.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/osv-full/img/icons/plus.svg#plus\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211.8\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/osv-full/img/icons/plus.svg#plus\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211.8\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/osv-full/img/icons/plus.svg#plus\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/car-comparison-tool" }
              });
          } else {
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">Car comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/osv-full/img/plus.svg#plus\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/osv-full/img/plus.svg#plus\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/osv-full/img/plus.svg#plus\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/car-comparison-tool" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          e.target.innerHTML = `<svg width="11.8" height="11.8"><use xlink:href="/themes/osv-full/img/plus.svg#plus"></use></svg>&nbsp;<span>Compare</span>`;
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Car Comparison')
            .setting({
              'title': 'Car Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/car-comparison-tool" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list', cookie_string)
        e.target.innerHTML = `<svg width="9.8" height="9.8"><use xlink:href="/themes/osv-full/img/minus.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Car Comparison')
          .setting({
            'title': 'Car Comparison',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/car-comparison-tool" }
          });
      }
    })
  })

});

// Contact Form
if(document.getElementById('send-contact-form')){
  // Do captcha and submit form

  let button = document.querySelector('#send-contact-form');
  let terms = document.querySelector('#contact-form [name=terms]');
  terms.onchange = function() {
    button.disabled = !this.checked;
  };

  document.getElementById('send-contact-form').addEventListener("click", function(e) {
    e.preventDefault();

    document.body.classList.remove('loaded');
    button.disabled = true;
    button.innerHTML = 'Sending...';

    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let email = document.querySelector('#contact-form [name=email]').value;
        let forename = document.querySelector('#contact-form [name=forename]').value;
        let surname = document.querySelector('#contact-form [name=surname]').value;
        let telephone = document.querySelector('#contact-form [name=telephone]').value;
        let postcode = document.querySelector('#contact-form [name=postcode]').value;
        let comments = document.querySelector('#contact-form [name=comments]').value;
        let callback = '';
        if (document.querySelector('#contact-form [name=date]') && document.querySelector('#contact-form [name=time]')){
          callback =`${document.querySelector('#contact-form [name=date]').value} ${document.querySelector('#contact-form [name=time]').value}`;
        }
        let csrf_token = document.querySelector('#contact-form [name=_token]').value;

        if (document.querySelector('#contact-form [name=subscribe]').checked) {
          fetch('/newsletter', {
            method: 'POST', // or 'PUT'
            body: JSON.stringify({
              'name': forename+' '+surname,
              'forename': forename,
              'surname': surname,
              'email': email,
              'mail_status': 'subscribed',
              '_token': csrf_token }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your sign up details\n\n'+errors);
            }

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Newsletter Signup'
            });

          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }

        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'name': forename+' '+surname,
            'forename': forename,
            'surname': surname,
            'email': email,
            'telephone': telephone,
            'comments': `POSTCODE: ${postcode} \n ADDITIONAL INFORMATION: ${comments}`,
            'callback_time': callback,
            '_token': csrf_token,
            'g-recaptcha-response': recaptcha_token
          }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          button.disabled = false;
          button.innerHTML = 'Submit Enquiry';
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status !== 'ok'){
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            return alert('There was a problem with your form\n\n'+errors);
          }

          button.disabled = false;
          button.innerHTML = 'Submit Enquiry';
          document.getElementsByClassName('contact-form')[0].reset();
          document.getElementsByClassName('contact-content')[0].classList.add('hidden');
          document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
          document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'General Enquiry Received'
          });


        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });

      });
    });

  });
}

// Map
if(document.getElementById('map')){

  let map_container = document.getElementById('map');
  let map_zoom = map_container.dataset.zoom;
  let map_lat_center = map_container.dataset.centerLat;
  let map_lng_center = map_container.dataset.centerLng;
  let map_lat = map_container.dataset.lat;
  let map_lng = map_container.dataset.lng;
  let map_lat_2 = map_container.dataset.lat2;
  let map_lng_2 = map_container.dataset.lng2;
  let map_lat_3 = map_container.dataset.lat3;
  let map_lng_3 = map_container.dataset.lng3;

  // Initialize and add the map
  function initMap() {
    var myOptions = {
      center: { lat: parseFloat(map_lat_center), lng: parseFloat(map_lng_center) },
      zoom: parseFloat(map_zoom),
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#444444"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#f2f2f2"
            }
          ]
        },
        {
          "featureType": "landscape.man_made",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#eae9ed"
            }
          ]
        },
        {
          "featureType": "landscape.natural",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#d2e0b7"
            }
          ]
        },
        {
          "featureType": "landscape.natural.landcover",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#d2e0b7"
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#d2e0b7"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": 45
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#b3dced"
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "off"
            },
            {
              "color": "#e6e6e6"
            }
          ]
        }
      ]
    };

    var map = new google.maps.Map( map_container, myOptions );
    if (map_lat && map_lng) {
      var marker = new google.maps.Marker({
        position: { lat: parseFloat(map_lat), lng: parseFloat(map_lng) },
        map: map,
        icon: { url: '/themes/osv-full/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
    if (map_lat_2 && map_lng_2) {
      var marker2 = new google.maps.Marker({
        position: { lat: parseFloat(map_lat_2), lng: parseFloat(map_lng_2) },
        map: map,
        icon: { url: '/themes/osv-full/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
    if (map_lat_3 && map_lng_3) {
      var marker3 = new google.maps.Marker({
        position: { lat: parseFloat(map_lat_3), lng: parseFloat(map_lng_3) },
        map: map,
        icon: { url: '/themes/osv-full/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
  }
}

// Subscribe Form
if(document.getElementById('email-signup')){
  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    var recaptcha_token = null;

    if(document.querySelector('input[name=g-recaptcha-response]')){
      recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
    } else {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
        recaptcha_token = token;
      });
    }

    document.getElementById('email-signup').classList.add('preload');
    document.getElementById('email-signup').innerHTML = '<span class="btn-loading">Please wait<span>';
    document.getElementById('email-signup').disabled = true;

    let url = '/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let name = document.getElementById('newsletter-name').value;
    let token = document.getElementsByName('_token')[0].value;

    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;

      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Whoops!',
            html: ('There was a problem with your sign up details\n\n'+$errors).replace(/\n/gi,'<br>'),
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          return alert('There was a problem with your sign up details\n\n'+$errors);
        }
      }

      document.getElementsByClassName('newsletter-form')[0].reset();
      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Signup'
      });

      if(typeof Swal !== 'undefined'){
        return Swal.fire({
          title: 'Thank you!',
          text: 'You\'re signed up!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        return alert('Thank you!');
      }

    }).catch(function(err) {
      console.error('Fetch Error -', err);
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;
    });
  });
}

function resetSearchForm () {
  const searchReset = document.querySelector('.search-form button.button-reset');
  if (searchReset) {
    const allFields = document.querySelectorAll('.search-form .form-group select');
    document.querySelector('.search-form').reset();
    searchReset.addEventListener('click', (e) => {
      allFields.forEach(value => {
        value.selectedIndex = 0;
        loadModels();
        loadSpecs();
      })
    })
  }
}


document.addEventListener("DOMContentLoaded", function() {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader


  //Lazy Load Images
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;

  const lazyLoad = function() {
    if (active === false) {
      active = true;


      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };

  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();
});

window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader

  function loadSearchForm () {
    // Load Search searchType
    if(document.getElementsByClassName('search-form').length>0){
      // Search
      let searchType = document.querySelector('#search-type').value;
      // loadManufacturers(searchType);
      if (document.querySelector('.ev-search')){
        loadEvManufacturers(searchType);
        loadEvModels(searchType);
      } else {
        // loadManufacturers(searchType);
        loadModels(searchType);
      }
      loadBodyTypes(searchType);

      document.querySelector('.search-form [name=search-type]').addEventListener("change", function(e){
        // loadManufacturers(this.value, e.target.value);
        if (document.querySelector('.ev-search')){
          loadEvManufacturers(this.value, e.target.value);
        } else {
          // loadManufacturers(this.value, e.target.value);
        }
        loadBodyTypes(this.value);
      });

      document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
        searchType = document.querySelector('#search-type').value;
        if (document.querySelector('.ev-search')){
          loadEvModels(searchType, e.target.value);
        } else {
          loadModels(searchType, e.target.value);
        }
      });

      if (document.querySelector('.search-form [name=model]')) {
        document.querySelector('.search-form [name=model]').addEventListener("change", function(e){
          searchType = document.querySelector('#search-type').value;
          loadSpecs(searchType, e.target.value);
        });
      }
    }
  }

  if (document.querySelector('#search-bar')){
    loadSearchForm();
    resetSearchForm();
  }

});